import { Button } from '@/components';
import { ButtonSize } from '@/interfaces';
import styled from 'styled-components';

export const DialogAction = styled(Button).attrs({ isPMTButton: true, size: ButtonSize.Large })(({ theme }) => ({
  marginTop: theme.spacing[24],
  width: '100%',
}));
